import Pokedex from '../components/pokedex/Pokedex';
import Skills from '../components/pokedex/Skills';

export default [
  {
    name: 'Pokedex',
    path: '/pokedex',
    component: Pokedex,
  },
  {
    name: 'Skills',
    path: '/skills',
    component: Skills,
  },
]
